<template>
  <div class="media">
    <div class="section-title">{{ $t('featuredIn') }}</div>
    <div class="media-list">
      <div v-for="(i, index) in partners" :key="index" class="media-item">
        <a v-if="i.link" :href="i.link">
          <img :src="i.icon" class="media-icon">
        </a>
        <img v-else :src="i.icon" class="media-icon">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  i18n: {
    messages: {
      en: {
        aboutUs: 'Safe Lending Practices',
        aboutUsTip: 'Fund disbursements will be distributed to consumer financing products. The borrower has gone through the screening process, and has a good and qualified credit score.',
        featuredIn: 'Featured In',
      },
      id: {
        aboutUs: 'Perlindungan Aset',
        aboutUsTip:
          'Penyaluran dana akan disalurkan kepada produk pinjaman tunai jangka pendek. Penerima pinjaman telah melalui proses penyaringan, dan memiliki riwayat pinjaman bagus dan berkualitas.',
        featuredIn: 'Liputan Media Oleh',
      },
    },
  },
  data() {
    return {
      partners: [
        {
          icon: require('@/assets/image/home/media/p1.png'),
          link: '',
        },
        {
          icon: require('@/assets/image/home/media/p2.png'),
          link: 'http://www.tribunnews.com/nasional/2018/08/11/mengenal-model-bisnis-fintech-lending',
        },
        {
          icon: require('@/assets/image/home/media/p3.png'),
          link: 'http://www.industry.co.id/read/44070/kredit-pintar-gandeng-komunitas-jendela-dukung-minat-baca-anak-anak-sejak-dini',
        },
        {
          icon: require('@/assets/image/home/media/p4.png'),
          link: '',
        },
        {
          icon: require('@/assets/image/home/media/p5.png'),
          link: 'https://www.gatra.com/rubrik/ekonomi/fintech/357252-Kredit-Pintar-Gelar--program-Bulan-Inklusi-Keuangan',
        },
        {
          icon: require('@/assets/image/home/media/p6.png'),
          link: 'https://edukasi.kompas.com/read/2018/10/19/21080111/fintech-perlu-peningkatan-keamanan-dan-pengawasan-pemerintah',
        },
        {
          icon: require('@/assets/image/home/media/p7.png'),
          link: 'https://dailysocial.id/post/-layanan-p2p-lending-kreditpintar-gunakan-teknologi-artificial-intelligence-untuk-proses-pinjaman',
        },
        {
          icon: require('@/assets/image/home/media/p8.png'),
          link: 'https://swa.co.id/swa/trends/fintech-days-bali-2018-tingkatkan-inklusi-keuangan',
        },
        {
          icon: require('@/assets/image/home/media/p9.png'),
          link: 'https://kumparan.com/swaonline/fintech-days-bali-2018-tingkatkan-inklusi-keuangan-1540517226276236215',
        },
        {
          icon: require('@/assets/image/home/media/p10.png'),
          link: 'https://republika.co.id/berita/ekonomi/fintech/18/10/24/ph3qoj383-penagihan-kredit-fintech-harus-sesuai-pedoman-aftech',
        },
        {
          icon: require('@/assets/image/home/media/p11.png'),
          link: 'https://keuangan.kontan.co.id/news/tekfin-kredit-pintar-telah-menyalurkan-pinjaman-lebih-dari-rp-1-triliun',
        },
        {
          icon: require('@/assets/image/home/media/p12.png'),
          link: 'http://infokomputer.grid.id/read/121253103/kredit-pintar-hadirkan-aplikasi-pendanaan-untuk-para-pengguna-android?page=2',
        },
        {
          icon: require('@/assets/image/home/media/p13.png'),
          link: 'https://www.digitalnewsasia.com/startups/kredit-pintar-uses-ai-speed-loan-processing',
        },
        {
          icon: require('@/assets/image/home/media/p14.png'),
          link: 'http://marketeers.com/langkah-awal-tahun-kredit-pintar-berikan-pilihan-investasi/',
        },
        {
          icon: require('@/assets/image/home/media/p15.png'),
          link: 'https://www.cnnindonesia.com/teknologi/20181116152650-185-347164/cermati-tiga-syarat-wajib-sebelum-pinjam-uang-lewat-aplikasi',
        },
        {
          icon: require('@/assets/image/home/media/p16.png'),
          link: '',
        },
        {
          icon: require('@/assets/image/home/media/p17.png'),
          link: 'http://www.koran-jakarta.com/teknologi-finansial-perluas-layanan/',
        },
        {
          icon: require('@/assets/image/home/media/p18.png'),
          link: 'https://id.investing.com/news/economy-news/perkuat-layanan-pendanaan-nasabah-kredit-pintar-for-lender-meluncur-di-perangkat-ios-408449',
        },
      ],
    }
  },
}
</script>

<style lang="stylus" scoped>
.media {
  background: #f8f8f8;
  margin: 0 auto;
  padding: 30px;
}

.section-title {
  margin: 0 0 20px;
}

.media-list {
  display grid
  grid-template-columns repeat(4, 66px)
  grid-row-gap 8px
  justify-content space-between
  .media-icon {
    width: 66px;
    height: 23px;
  }
}

</style>
